import { Outlet } from "react-router-dom";

export default function CustomerSupportOutlet() {
  return <Outlet />;
}
